import type { PostFields } from '@tribeplatform/gql-client/graphql'
import type { QueryFeedArgs } from '@tribeplatform/gql-client/types'

import { KeyConstructor } from './keyConstructor.js'

const FEED_KEY = 'feed'

export const getFeedKey = KeyConstructor<QueryFeedArgs, PostFields>(FEED_KEY)
